import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { __ } from '@montblancsimpl/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import OktaAuth from '@okta/okta-auth-js';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authEndpoints = environment.oktaSettings.endpoints;

    const isProtectedEndpoint = authEndpoints.some((origin) => req.url.startsWith(origin));

    if (isProtectedEndpoint) {
      const accessToken = this.oktaAuth.getAccessToken();

      if (__.IsNullOrUndefinedOrEmpty(accessToken)) {
        return next.handle(req);
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return next.handle(authReq);
    } else {
      return next.handle(req);
    }
  }
}
